var map = {
	"./Feet/TerribleBoots/TerribleBoots.png": 1211,
	"./Feet/TerribleBoots/TerribleBoots_L.fbx": 7450,
	"./Feet/TerribleBoots/TerribleBoots_R.fbx": 5116,
	"./Hands/TerribleGloves/TerribleGloves.png": 293,
	"./Hands/TerribleGloves/TerribleGloves_L.fbx": 2886,
	"./Hands/TerribleGloves/TerribleGloves_R.fbx": 9376,
	"./Head/BallCapBackward/BallCapBackward.fbx": 8233,
	"./Head/BallCapBackward/BallCapBackward.png": 4533,
	"./Head/BallCapBackward/BallCapBackward.thumbnail.png": 4763,
	"./Head/BallCapForward/BallCapForward.fbx": 2567,
	"./Head/BallCapForward/BallCapForward.png": 5615,
	"./Head/BallCapForward/BallCapForward.thumbnail.png": 2761,
	"./Head/CheesyGlasses/CheesyGlasses.fbx": 5493,
	"./Head/CheesyGlasses/CheesyGlasses.png": 2865,
	"./Head/CheesyGlasses/CheesyGlasses.thumbnail.png": 7383,
	"./Head/ConeHat/ConeHat.fbx": 9637,
	"./Head/ConeHat/ConeHat.png": 489,
	"./Head/ConeHat/ConeHat.thumbnail.png": 5551,
	"./Head/Headphones/Headphones.fbx": 9149,
	"./Head/Headphones/Headphones.png": 7761,
	"./Head/Headphones/Headphones.thumbnail.png": 8647,
	"./Head/Horns/Horns.fbx": 1153,
	"./Head/Horns/Horns.png": 8101,
	"./Head/Horns/Horns.thumbnail.png": 8699,
	"./Head/LibertySpikes/LibertySpikes.fbx": 3485,
	"./Head/LibertySpikes/LibertySpikes.png": 1345,
	"./Head/LibertySpikes/LibertySpikes.thumbnail.png": 1095,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.fbx": 4209,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.png": 5125,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.thumbnail.png": 5819,
	"./Head/SantaHat/SantaHat.fbx": 3427,
	"./Head/SantaHat/SantaHat.png": 2871,
	"./Head/SantaHat/SantaHat.thumbnail.png": 513,
	"./Head/Sideburns/Sideburns.fbx": 8125,
	"./Head/Sideburns/Sideburns.png": 8673,
	"./Head/Sideburns/Sideburns.thumbnail.png": 1687,
	"./Head/TopHat/TopHat.fbx": 6211,
	"./Head/TopHat/TopHat.png": 3563,
	"./Head/TopHat/TopHat.thumbnail.png": 4229,
	"./legs/TerriblePants/TerriblePants.fbx": 9296,
	"./legs/TerriblePants/TerriblePants.png": 9728,
	"./torso/TerribleShirt/TerribleShirt.fbx": 8928,
	"./torso/TerribleShirt/TerribleShirt.png": 5530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4167;